import { useEffect, useState } from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import bgLight from "../assets/hero-bg2-light.png";
import bgDark from "../assets/hero-bg2-dark.png";

const headshot = `${process.env.PUBLIC_URL}/media/headshot.webp`;

export default function Hero() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    const updateTheme = () => setIsDark(root.classList.contains("dark"));

    updateTheme(); // set initial value

    // React to dark-mode toggles made elsewhere (e.g. the navbar)
    const observer = new MutationObserver(updateTheme);
    observer.observe(root, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative bg-light dark:bg-dark text-black dark:text-light overflow-hidden">
      {/* Faint background texture (swaps with theme) */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <img
          src={isDark ? bgDark : bgLight}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover opacity-10 dark:opacity-20"
        />
      </div>

      {/* Hero content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-28 pb-24 grid grid-cols-1 md:grid-cols-[1.12fr_0.88fr] gap-14 items-center">
        {/* Text column */}
        <div className="order-2 md:order-1">
          <p className="font-mono text-[13px] tracking-wider uppercase text-accent mb-4">
            Certified Tridium Niagara Developer &amp; Engineer
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight mb-6">
            Building drivers,<br />
            dashboards &amp; <span className="text-accent">systems</span><br />
            that just work.
          </h1>
          <p className="text-lg text-muted dark:text-pale max-w-xl">
            I design and ship production Niagara modules and front-end apps, with a
            focus on clean code, reliable integrations, and interfaces people actually
            want to use.
          </p>

          <div className="flex items-center gap-3.5 mt-9">
            <a
              href="#projects"
              className="font-mono text-[13px] bg-accent text-light px-5 py-3 rounded hover:opacity-90 transition"
            >
              View selected work →
            </a>
            <a
              href="https://www.linkedin.com/in/james-clyne-971b23116"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn profile"
              className="font-mono text-[13px] flex items-center gap-2 border border-black/15 dark:border-white/15 px-5 py-3 rounded hover:border-accent hover:text-accent transition"
            >
              <LinkedInIcon fontSize="small" /> LinkedIn
            </a>
          </div>
        </div>

        {/* Portrait column */}
        <div className="order-1 md:order-2 relative w-full max-w-[340px] justify-self-center md:justify-self-end">
          {/* Offset accent frame */}
          <div className="hidden md:block absolute -bottom-4 -right-4 top-4 left-4 border border-accent/50 rounded-md z-0" />
          <img
            src={headshot}
            alt="James Clyne"
            className="relative z-10 w-full aspect-[4/5] object-cover object-[center_18%] rounded-md border border-black/10 dark:border-white/10 grayscale contrast-[1.03]"
          />
          <div className="absolute z-20 left-3 bottom-3 font-mono text-[11.5px] tracking-wide bg-light/75 dark:bg-dark/75 backdrop-blur-sm border border-black/10 dark:border-white/10 rounded px-2.5 py-1.5">
            <span className="text-accent">James Clyne</span>, Developer &amp; Engineer
          </div>
        </div>
      </div>
    </section>
  );
}
